import React, { useCallback, useContext, useEffect, useState } from 'react'
import { CityDropdownForTrip, CommonInput, CrossButton, CustomSelect } from 'components'
import { errorSchema, utils } from 'helper';
import { City, State } from "country-state-city";
import Dropdown from 'components/common/Customdropdown/Dropdown';
import StorageService from "utils/StorageServices/StorageServices";
import { UserContext } from "context";
import debounce from 'lodash.debounce';
import toast, { Toaster } from 'react-hot-toast';
import { createConsignor, getAllConsignorgGroup, getConsignorListData } from '_services/accountsServices/consignorServices';
import { AddButton } from 'components/common/CommonButton';
import { constant } from 'constants/constant';
import { createVehicle, editVehicle } from '_services/accountsServices/vehicleServices';
import { getOwnDriverListData } from '_services/accountsServices/ownDriverServices';
import { getSupplierListData } from '_services/accountsServices/supplierServices';
import { getLorryTypeList } from '_services/accountsServices/lrServices';
import { useNavigate } from 'react-router-dom';
import { getAllDriver, getAllSupplier, handleKeyDown } from '_services';
import { getDriverDropdownListData } from '_services/dropdownServices/dropdownService';
import { Link } from 'react-router-dom';
import { getFirm, getUserFirm } from '_services/accountsServices/firmServices';
import FirmImg from '../../assets/img/firm.png';
import { FaYoutube } from 'react-icons/fa6';
import YoutubeModal from 'modals/YoutubeModal';
import { getVehicleGroupListData } from '_services/accountsServices/vehicleGroupServices';
import FetchVehicleDocModal from 'modals/FetchVehicleDocModal';
import { getVehicleDocumentsListData, VehicleDocumentFetch } from '_services/accountsServices/vehicleDocTypeServices';

const formObj = {
    company_id: StorageService.getCompanyId(),
    vehicle_no: '',
    vehicle_ownership: 1,
    lorry_type_id: '',
    vehicle_type_id_1: {},

    manage_trip_kms: 2,//0-None, 1-Mandatory, 2-Non-Mandatory
    manage_fuel: false,//true-Checked, false-Non-Checked
    vehicle_average: '',
    opening_fuel: '',
    fuel_amount: '',
    fuel_rate: '',
    fuel_out: '',//0-None, 1-Editable, 2-Non-Editable

    driver_id: '',
    supplier_id: '',
    firm_id: {},
    vehicle_group: {}
    // weight_passing: '',
}

const AddEditVehicleModal = ({
    isOpen,
    onClose,
    callBackVehicle = (data) => { },
    callBackVehicleFleet = (data) => { },
    handleAddNewSupplierButtonAction,
    handleAddNewVehicleButtonAction,
    isSupplier = false,
    isDriver = false,
    isListFunctionCall = {},
    isChildDriverSuplier = false,
    showOnlyOwn_Leased = true,
    showOwn_no_Leased = false,
    title = "",
    hideAddNewOption = true,
    branchFirmId,
    titleText = "",
    documentAutoFetch = true
}) => {
    const navigate = useNavigate();
    const { masterData, cities, states, vehicleDriverSupplierFirm, setVehicleDriverSupplierFirm, mastersChild, youtubeVideos, setYoutubeVideos } = useContext(UserContext)
    const masterChildSupplier = mastersChild?.find((i) => i?.label === "Supplier");
    const masterChildDriver = mastersChild?.find((i) => i?.label === "Driver");



    const [formValue, setFormValue] = useState(formObj);
    const [formError, setFormError] = useState({});
    const [tyrelabel, setTyreLabel] = useState('')
    const [loading, setLoading] = useState(false);
    const [driverList, setDriverList] = useState([])
    const [supplierList, setSupplierList] = useState([])
    const [lorryType, setLorryType] = useState([]);

    const [fetchDocuments, setFetchDocuments] = useState({});

    const [vehicleGroupData, setVehicleGroupData] = useState([]);

    const [activeTab, setActiveTab] = useState({});
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);

    const [isStateClear, setIsStateClear] = useState(0);

    const [firmDataList, setFirmDataList] = useState([]);

    const handleOnChange = async (name, value) => {
        const stateObj = { ...formValue, [name]: value };
        setFormValue(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, errorSchema.createVehicleSchema);
            if (validationResult === true) {
                setFormError("");
            } else {
                setFormError(validationResult);
            }
        }
    };

    const getDataVehicleDocumentList = async (response) => {
        setLoading(true);
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                limit: 25,
                offset: 1,
                search: '',
                vehicle_no: response?.vehicle_no ? response?.vehicle_no : '',
            }
            const res = await getVehicleDocumentsListData(object);
            if (res?.responseCode == 200) {
                let document = [...res?.data?.documents, ...res?.data?.unused_doc_types];
                setFetchDocuments({ openModal: true, document, response, isFetch: res?.data?.documents?.length > 0 ? true : false });
                setLoading(false);
                // setCount((s) => ({ ...s, total: res?.data?.document_count }))
                // setTotalItems(res?.data?.document_count);
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const apiCallingFunction = async (shouldCloseModal) => {
        try {
            let object = {
                ...formValue,
                firm_id: formValue?.firm_id?.value ? formValue?.firm_id?.value : '',
                driver_id: (formValue?.vehicle_ownership === 1 || formValue?.vehicle_ownership === 3) ? formValue?.driver_id?.value : '',
                supplier_id: formValue?.vehicle_ownership === 2 ? formValue?.supplier_id?.value : '',
                vehicle_type_id_1: formValue?.vehicle_type_id_1?.value,
                vehicle_group: formValue?.vehicle_group?.value ? { name: formValue?.vehicle_group?.label, _id: formValue?.vehicle_group?.value } : {},
                fuel_rate: (formValue?.fuel_amount > 0 && formValue?.opening_fuel > 0) ? (formValue?.fuel_amount / formValue?.opening_fuel).toFixed(2) : ''
            }
            const res = await createVehicle(object);

            if (res?.responseCode === 200) {
                if (documentAutoFetch) {
                    getDataVehicleDocumentList(res?.data?.vehicle);
                }
                setFormValue({});
                setLoading(false);
                toast.success('Vehicle Created Successfully');
                if (shouldCloseModal) {
                    if (!documentAutoFetch) {
                        onClose(false);
                    }
                } else {
                    setActiveTab(1); // Reset tab to the first tab
                }
                callBackVehicleFleet(res?.data);
                callBackVehicle(res?.data?.vehicle);


                isListFunctionCall();
            } else {
                if (res?.responseMessage) {
                    toast.error(`${res?.responseMessage}`);
                }
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        } finally {
            setIsButtonDisabled(false);
        }
    }

    const editApiCallingFunction = async (shouldCloseModal) => {
        try {
            let object = {
                firm_id: formValue?.firm_id?.value ? formValue?.firm_id?.value : '',
                company_id: StorageService.getCompanyId(),
                vehicle_no: formValue.vehicle_no,
                vehicle_ownership: formValue?.vehicle_ownership,
                lorry_type_id: formValue.lorry_type_id,
                manage_trip_kms: formValue.manage_trip_kms,
                manage_fuel: formValue.manage_fuel,
                fuel_out: formValue.fuel_out,
                vehicle_id: isOpen?._id,
                fuel_amount: formValue?.fuel_amount !== null ? formValue?.fuel_amount : '',
                vehicle_average: formValue?.vehicle_average !== null ? formValue?.vehicle_average : '',
                opening_fuel: formValue?.opening_fuel !== null ? formValue?.opening_fuel : '',
                weight_passing: formValue?.weight_passing !== null ? formValue?.weight_passing : '',
                driver_id: (formValue?.vehicle_ownership === 1 || formValue?.vehicle_ownership === 3) ? formValue?.driver_id?.value : '',
                supplier_id: formValue?.vehicle_ownership === 2 ? formValue?.supplier_id?.value : '',
                vehicle_type_id_1: formValue?.vehicle_type_id_1?.value,
                vehicle_group: formValue?.vehicle_group?.value ? { name: formValue?.vehicle_group?.label, _id: formValue?.vehicle_group?.value } : {},
                fuel_rate: (formValue?.fuel_amount > 0 && formValue?.opening_fuel > 0) ? (formValue?.fuel_amount / formValue?.opening_fuel).toFixed(2) : ''
            }
            delete object.last_kms;
            delete object.fastag;
            delete object.gps_data;
            delete object.gps_settings;
            delete object._id;
            delete object.active;
            delete object.is_deleted;
            delete object.vehicle_type_id;
            delete object.available_fuel;
            delete object.average_fuel_rate;
            delete object.available_fuel_amount;
            delete object.created_by;
            delete object.vehicle_status;
            delete object.createdAt;
            delete object.updatedAt;
            delete object.trip_id;
            delete object.revenue;
            delete object.end_location;
            const res = await editVehicle(object);
            if (res?.responseCode === 200) {
                setFormValue({});
                setLoading(false);
                if (res?.responseMessage) {
                    toast.success('Vehicle Updated Successfully');
                }
                if (shouldCloseModal) {
                    onClose(false);
                } else {
                    setActiveTab(1); // Reset tab to the first tab
                }
                callBackVehicle(res?.data?.vehicle)
                isListFunctionCall();
            } else {
                if (res?.responseMessage) {
                    toast.error(`${res?.responseMessage}`);
                }
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        } finally {
            setIsButtonDisabled(false);
        }
    }

    const handleClick = async (e) => {
        e.preventDefault();
        const validationResult = await utils?.checkFormError(formValue, errorSchema.createVehicleSchema);

        if (utils?.isObjectKeyEmpty(validationResult)) {
            if (isOpen?._id) {
                setLoading(true);
                await editApiCallingFunction(true);
            } else {
                setLoading(true);
                await apiCallingFunction(true); // Pass true to close the modal
            }
            setFormError("");
        } else {
            setFormError(validationResult);
            setLoading(false);
        }
    };

    const handleResetFormAndSubmit = async (e) => {
        e.preventDefault();
        setIsButtonDisabled(true); // Disable the button immediately
        const validationResult = await utils?.checkFormError(formValue, errorSchema.createVehicleSchema);
        if (utils?.isObjectKeyEmpty(validationResult)) {
            setLoading(true);
            await apiCallingFunction(false); // Pass false to keep the modal open and reset the form
            setFormValue((prevData) => ({
                ...prevData,
                company_id: StorageService.getCompanyId(),
                vehicle_no: '',
                vehicle_ownership: 1,
                lorry_type_id: '',
                // vehicle_type_id_1: {},
                // vehicle_type_id_2: '',
                driver_id: '',
                supplier_id: '',
                vehicle_average: '',
                weight_passing: '',
            }))
            setTyreLabel({ label: '', value: '' })
            setFormError("");
        } else {
            setFormError(validationResult);
            setLoading(false);
            setIsButtonDisabled(false); // Re-enable the button if moving to the next tab
        }
    }

    const maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }

    const getDataDriverList = async (nestedObjPrefield, firmData) => {
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                firm_id: firmData?.value ? firmData?.value : StorageService.getFirmId(),
                limit: 100,
                offset: 1,
                search: '',
                status: 1,
                driver_type: 1,
            }
            const res = await getDriverDropdownListData(object);
            // const res = await getOwnDriverListData(object);
            if (res?.responseCode == 200) {
                setDriverList(res?.data?.driver_list)

                if (nestedObjPrefield?.defaultSelect) {
                    setFormValue((s) => ({
                        ...s,
                        driver_id: res?.data?.driver_list?.map((el) => {
                            return {
                                ...el,
                                label: el?.name,
                                value: el?._id
                            }
                        })[0],
                    }));
                }

            }
        } catch (error) {
            // throw error;
        }
    }

    const getDataSupplierList = async (nestedObjPrefield, firmData) => {
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                firm_id: firmData?.value ? firmData?.value : StorageService.getFirmId(),
                limit: 100,
                offset: 1,
                search: '',
                status: 1
            }
            const res = await getSupplierListData(object);
            if (res?.responseCode == 200) {
                let list = res?.data?.supplier_list?.map((el) => {
                    return {
                        ...el,
                        label: el?.name,
                        value: el?._id
                    }
                })
                setSupplierList(list)
                if (nestedObjPrefield?.defaultSelect) {
                    setFormValue((s) => ({
                        ...s,
                        supplier_id: list[0],
                    }));
                }
            }
        } catch (error) {
            // throw error;
        }
    }

    const onhandleSelect = async (item, name) => {
        const stateObj = { ...formValue, [name]: item };
        setFormValue(stateObj);

        if (name === 'firm_id') {
            stateObj['driver_id'] = {};
            stateObj['supplier_id'] = {};
        }

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, errorSchema.createVehicleSchema);
            if (validationResult === true) {
                setFormError({});
            } else {
                setFormError(validationResult);
            }
        }
    };

    const changeActiveTab = async (event, value) => {
        event.preventDefault();
        setActiveTab(value);
        setTyreLabel({ label: '', value: '' })
        setFormValue((s) => ({ ...s, vehicle_type_id_1: {} }))
    };

    const getDataLorryTypeList = async () => {
        try {
            const res = await getLorryTypeList();
            if (res?.responseCode == 200) {
                setLorryType(res?.data?.lorry_type)
                if (!isOpen?._id) {
                    setActiveTab(res?.data?.lorry_type[0])
                }
            }
        } catch (error) {
            // throw error;
        }
    }

    const fetchDriver = async (search, page, limit) => {

        const res = await getAllDriver({
            company_id: StorageService.getCompanyId(),
            firm_id: branchFirmId?._id ? branchFirmId?._id : (formValue.firm_id?.value ? formValue.firm_id?.value : StorageService.getFirmId()),
            limit,
            offset: page,
            search,
            status: 1,
            driver_type: [1, 3],
        });

        if (res?.responseCode === 200) {
            setLoading(false);
            const list = await res?.data?.driver_list?.map((i) => ({
                ...i,
                label: i?.name,
                value: i?._id
            }));

            return {
                items: list,
                total: res?.data?.total_record,
            };
        } else {
            setLoading(false);
            toast.error(res?.responseMessage);
        }
    };


    const fetchSupplier = async (search, page, limit) => {
        const res = await getAllSupplier({
            company_id: StorageService.getCompanyId(),
            firm_id: branchFirmId?._id ? branchFirmId?._id : (formValue.firm_id?.value ? formValue.firm_id?.value : StorageService.getFirmId()),
            offset: page,
            limit,
            search,
        });

        if (res?.responseCode === 200) {
            setLoading(false);
            const list = await res?.data?.supplier_list?.map((i) => ({
                ...i,
                label: i?.name,
                value: i?._id
            }));

            return {
                items: list,
                total: res?.data?.total_record,
            };
        } else {
            setLoading(false);
            toast.error(res?.responseMessage);
        }
    };

    const getDataVehicleGroupList = async () => {
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                offset: 1,
                limit: 100
            }
            const res = await getVehicleGroupListData(object);
            if (res?.responseCode == 200) {

                let finalArray = res?.data?.vehicle_group_list?.map((el) => {
                    return {
                        label: el?.name,
                        value: el?._id,
                    }
                })
                setVehicleGroupData(finalArray);
            }
        } catch (error) {
            //   throw error;
        }
    }

    useEffect(() => {
        // getDataDriverList();
        // getDataSupplierList();
        getDataLorryTypeList();
        getDataVehicleGroupList();
        if (StorageService.getCompanyId()) {
            setFormValue((s) => ({ ...s, company_id: StorageService.getCompanyId() }))
        }
    }, [StorageService.getCompanyId()])

    useEffect(() => {
        if (isSupplier) {
            getDataSupplierList({ defaultSelect: true });
        }
    }, [isSupplier])

    useEffect(() => {
        if (isDriver) {
            getDataDriverList({ defaultSelect: true });
        }
    }, [isDriver])

    // useEffect(() => {
    //     if (!isOpen?._id) {
    //         setFormValue((s) => ({
    //             ...s,
    //             // driver_id: driverList?.map((el) => {
    //             //     return {
    //             //         label: el?.name,
    //             //         value: el?._id
    //             //     }
    //             // })[0],
    //             // supplier_id: supplierList[0],
    //         }));
    //     }
    // }, [supplierList, lorryType]);

    useEffect(() => {
        setFormValue((s) => ({
            ...s,
            lorry_type_id: activeTab?._id,
        }))
    }, [activeTab])

    useEffect(() => {
        if (!isOpen?._id) {
            setActiveTab(lorryType[0]);
        }
    }, [lorryType])

    useEffect(() => {
        setFormValue((s) => ({
            ...s,
            manage_trip_kms: 0,
            manage_fuel: false,
            vehicle_average: '',
            opening_fuel: '',
            fuel_amount: '',
            fuel_rate: '',
            fuel_out: 0,
        }));
    }, [isStateClear])

    useEffect(() => {
        if (lorryType?.length > 0 && isOpen?._id) {
            let isSetVehicleTabs = lorryType?.find((element) => {
                if (element?._id === isOpen?.lorry_type_id?._id) {
                    return element
                }
            })
            setActiveTab(isSetVehicleTabs);
            setTyreLabel({ label: isOpen?.vehicle_type_id?.name ? isOpen?.vehicle_type_id?.name : '', value: isOpen?.vehicle_type_id?._id ? isOpen?.vehicle_type_id?._id : '' },)
            setFormValue((s) => ({
                ...s,
                ...isOpen,
                firm_id: {
                    ...isOpen?.firm_id,
                    label: isOpen?.firm_id?.firm,
                    value: isOpen?.firm_id?._id
                },
                vehicle_group: isOpen?.vehicle_group?._id ? { label: isOpen?.vehicle_group?.name, value: isOpen?.vehicle_group?._id } : {},
                vehicle_type_id_1: { label: isOpen?.vehicle_type_id?.name ? isOpen?.vehicle_type_id?.name : '', value: isOpen?.vehicle_type_id?._id ? isOpen?.vehicle_type_id?._id : '' },
                driver_id: { label: isOpen?.driver_id?.name ? isOpen?.driver_id?.name : '', value: isOpen?.driver_id?._id ? isOpen?.driver_id?._id : '' },
                supplier_id: { label: isOpen?.supplier_id?.name ? isOpen?.supplier_id?.name : '', value: isOpen?.supplier_id?._id ? isOpen?.supplier_id?._id : '' },
            }))
        }
    }, [isOpen, lorryType])

    const getDataFirmList = async () => {
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
            }
            const res = await getUserFirm(object);
            if (res?.responseCode == 200) {
                let apiData = res?.data?.firm_list?.map((el) => {
                    return {
                        ...el,
                        label: el?.firm_id?.firm,
                        value: el?.firm_id?._id,
                    }
                })
                setFirmDataList(apiData);
                if (!isOpen?._id) {
                    if (apiData?.length === 1) {
                        setFormValue((s) => ({
                            ...s,
                            firm_id: apiData[0]
                        }))
                    } else {
                        setFormValue((s) => ({
                            ...s,
                            firm_id: {}
                        }))
                    }
                }
            }
        } catch (error) {
        }
    }

    useEffect(() => {
        getDataFirmList();
    }, [])

    // useEffect(() => {
    //     if (firmDataList?.length > 0 && !isOpen?._id) {
    //         let findObject = firmDataList?.find((el) => el?.value === StorageService.getFirmId());
    //         setFormValue((s) => ({
    //             ...s,
    //             firm_id: findObject?.value ? findObject : {}
    //         }))
    //     }
    // }, [StorageService.getFirmId(), firmDataList, isOpen])

    useEffect(() => {

        if (firmDataList?.length > 0 && !isOpen?._id) {
            const storageFirmId = StorageService.getFirmId();

            let findObject = firmDataList.find((el) => el?.value === storageFirmId);

            const branchFirm = branchFirmId?._id;
            let vehicleFirmObject = firmDataList.find((el) => el?.value === branchFirm);

            setFormValue((s) => ({
                ...s,
                ...(vehicleFirmObject ? { firm_id: vehicleFirmObject } : findObject ? { firm_id: findObject } : {})
            }));
        }
    }, [StorageService.getFirmId(), firmDataList, isOpen?._id, branchFirmId]);

    useEffect(() => {
        if (formValue?.vehicle_ownership && !isOpen?._id) { // ✅ सिर्फ Add mode में clear करो
            setFormValue((f) => ({
                ...f,
                driver_id: f?.vehicle_ownership == 2 ? {} : f.driver_id,
                supplier_id: f.vehicle_ownership != 2 ? {} : f.supplier_id,
                vehicle_group: vehicleGroupData[0]
            }))
        }

    }, [formValue?.vehicle_ownership, vehicleGroupData])

    const lrHandleKeyDown = (e) => {
        if (e.key === '-' || e.key === '+' || e.key === '.' || e.key === 'e') {
            e.preventDefault();
        }
    };

    const youtubeProps = {
        isOpen: youtubeVideos,
        closeModal: () => setYoutubeVideos((s) => ({ ...s, moduleName: '', moduleAction: false })),
        headerPart: false,
        modalTitle: `Add Vehicle`,
        submitTitle: `Add Vehicle`,
        modalMainClass: "_mdModal",
        videosModuleName: constant.Key.vehicle
    }

    const clickHandler = () => {
        navigate(`/account/vehicle/details/${fetchDocuments?.response?._id}?type=${constant.m_type.vehicle}&tab=${1}&search=${fetchDocuments?.response?.vehicle_no}&offset=${1}&total_record=${25}&vehicle_no=${fetchDocuments?.response?.vehicle_no}&is_list=${true}`)
    }

    const handleDocumentFetch = async () => {
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                vehicle_no: fetchDocuments?.response?.vehicle_no ? fetchDocuments?.response?.vehicle_no : ''
            }
            const res = await VehicleDocumentFetch(object);
            if (res?.responseCode == 200) {
                if (res.responseMessage === "Vehicle documents added successfully.") {
                    toast.success(res.responseMessage);
                } else {
                    toast.error(res.responseMessage);
                }
            }
        } catch (error) {
            console.error(error);
            toast.error("Something went wrong!");
        } finally {
        }
    }

    const fetchDocModalProps = {
        isOpen: fetchDocuments,
        onClose: (e) => setFetchDocuments(false),
        modalZIndex: 1050,
        onRefresh: (e) => handleDocumentFetch(e),
        onUpdate: (e) => clickHandler(e),
        onContinue: (e) => { setFetchDocuments(false); onClose(false) },
    };

    return (
        <>
            <div className={formValue?.firm_id?.label ? `offcanvas-header offcan_header` : `offcanvas-header`}>
                {formValue?.firm_id?.label ?
                    <div>
                        <h5 className="offcanvas-title">{isOpen?._id ? 'Update Vehicle' : 'Add Vehicle'}</h5>
                        <p className='offcanvas_heading_head'>
                            <img src={FirmImg} className='firm_icon_img' /> {" "}
                            {formValue?.firm_id?.label ? formValue?.firm_id?.label : <Link to='/setting/firm'> Create Firm </Link>}
                        </p>
                    </div>
                    :
                    <h5 className="offcanvas-title">{isOpen?._id ? 'Update Vehicle' : 'Add Vehicle'}</h5>
                }

                <div className="flxs_lr_cls">
                    {!isOpen?._id && (
                        <div className="youtube_Icon" onClick={(e) => setYoutubeVideos((s) => ({ ...s, moduleName: 'vehicle_creation', moduleAction: true }))}>
                            <button><FaYoutube size={36} /></button>
                        </div>
                    )}
                    <CrossButton type="button" className="_switchBtn  __animEffect_btn" style={{ marginLeft: 'auto' }} onClick={(e) => onClose(false)}>
                        <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none" >
                            <path
                                d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
                                fill="black"
                            />
                        </svg>
                    </CrossButton>
                </div>
            </div>

            <div className="offcanvas-body">

                <div className='pr_procssBx'>
                    <div className='pr_procssBx_grid'>

                        <div className='singleDiv'>
                            <CommonInput
                                type="text"
                                // placeholder="Vehicle No"
                                label="Vehicle No *"
                                name='vehicle_no'
                                placeholder="Enter vehicle number (e.g., KA01AB1234)"
                                maxLength={10} // Set maxLength to 10 characters
                                value={formValue.vehicle_no}
                                focus={!!(typeof formError === "object" && formError?.vehicle_no)}
                                error={!!(typeof formError === "object") ? formError?.vehicle_no : ""}
                                onChange={({ target: { name, value } }) => {
                                    const cleaned = value.replace(/[^A-Za-z0-9]/g, "");
                                    handleOnChange(name, cleaned.toUpperCase());
                                }}
                            />
                        </div>
                    </div>

                    <div className='checkBx_lv mt-2'>
                        {
                            (showOnlyOwn_Leased ? constant.vehicleOwnership : showOwn_no_Leased ? constant.vehicleOwnershipTxn : constant.vehicleOwnershipService)?.map((el, ind) => {
                                return (
                                    <React.Fragment key={ind}>
                                        <input
                                            className="form-check-input _avPointer"
                                            id={+ind + "vehicle_ownership" + el?.value}
                                            type="radio"
                                            name="vehicle_ownership"
                                            disabled={isOpen?._id && titleText == "trip"}
                                            checked={Number(formValue?.vehicle_ownership) === Number(el?.value)}
                                            value={formValue?.vehicle_ownership ? formValue?.vehicle_ownership : ""}
                                            onChange={({ target: { name, value } }) => {
                                                setIsStateClear(el?.value);
                                                handleOnChange(name, el?.value)
                                            }}
                                        />
                                        <label htmlFor={+ind + "vehicle_ownership" + el.value} className="form-check-label" >
                                            {el.label}
                                        </label> &nbsp;
                                    </React.Fragment>
                                )
                            })
                        }
                    </div>
                </div>

                <div className='addPr_flBx '>
                    <ul className="nav nav-tabs cstNew_tabs _truckSelection" id="addParty" role="tablist" style={{ padding: '8px 15px 8px 18px' }}>
                        <li className='singleDiv'><h4 className='_trkHead'>Select Fleet Type</h4></li>
                        {lorryType?.length > 0 ? lorryType?.map((item, indx) => (
                            <li
                                className="nav-item"
                                role="presentation"
                                key={indx}
                            >
                                <button id={item?.lorry_type}
                                    className={
                                        "nav-link " + (activeTab?.lorry_type === item?.lorry_type ? "active" : "")
                                    }
                                    type="button"
                                    aria-selected={activeTab?.lorry_type === item?.lorry_type}
                                    onClick={(e, val) => changeActiveTab(e, item)}
                                >
                                    {/* <span> <img src={`${masterData?.s3_url}${item?.icon}`} alt={item?.lorry_type} />  </span> */}
                                    {item?.lorry_type}
                                </button>
                            </li>
                        )) : <p className='p-2 mt-3'> Loading... </p>}
                    </ul>

                    <div className='pr_procssBx' id="addPartyContent">
                        <div className='pr_procssBx_grid'>

                            <div className='singleDiv'>
                                <CustomSelect
                                    options={vehicleGroupData}
                                    name="vehicle_group"
                                    label="Vehicle Group"
                                    placeholder="Vehicle Group"
                                    value={formValue?.vehicle_group?.label ? formValue?.vehicle_group : {}}
                                    error={formError["vehicle_group.label"]}
                                    onSelect={(data) => onhandleSelect(data, 'vehicle_group')}
                                />
                            </div>

                            <div className='singleDiv'>
                                <CustomSelect
                                    options={(activeTab && activeTab?.props?.length > 0 && activeTab?.props[0]?.values?.length > 0) ? activeTab?.props[0]?.values?.map((el) => {
                                        return {
                                            label: el?.name,
                                            value: el?._id
                                        }
                                    }) : []}
                                    name="vehicle_type_id_1"
                                    flotingLabel="Type * "
                                    placeholder={activeTab?.props?.length > 0 && activeTab?.props[0]?.key_label ? activeTab?.props[0]?.key_label : 'Select Type'}
                                    value={tyrelabel}
                                    // focus={!!(typeof formError === "object" && formError?.vehicle_type_id_1)}
                                    error={formError["vehicle_type_id_1.label"]}
                                    onSelect={(data) => {
                                        onhandleSelect(data, 'vehicle_type_id_1')
                                        setTyreLabel(data)
                                    }}
                                />
                            </div>

                            <div className='singleDiv _relatePos'>
                                <CommonInput
                                    type="text"
                                    placeholder="Weight Passing"
                                    label="Weight Passing"
                                    name='weight_passing'
                                    value={formValue.weight_passing}
                                    maxLength="10"
                                    onInput={utils.maxLengthCheck}
                                    onKeyDown={(e) => lrHandleKeyDown(e)}
                                    focus={!!(typeof formError === "object" && formError?.weight_passing)}
                                    error={!!(typeof formError === "object") ? formError?.weight_passing : ""}
                                    onChange={({ target: { name, value } }) => {
                                        if (/^\d*$/.test(value)) {
                                            handleOnChange(name, value);
                                        }
                                    }}

                                />
                                <span className='_weightSpan' > Tons </span>
                            </div>

                            {!isOpen?._id && firmDataList?.length > 1 && <div className='singleDiv'>
                                <CustomSelect
                                    options={firmDataList}
                                    label="Select Firm"
                                    placeholder="Select Firm"
                                    name="firm_id"
                                    value={formValue?.firm_id}
                                    error={formError["firm_id.label"]}
                                    onSelect={(data) => onhandleSelect(data, 'firm_id')}
                                    disabled={hideAddNewOption ? false : branchFirmId ? (formValue?.firm_id?.value ? true : false) : false}
                                />
                            </div>}

                            <div>
                                <div className='singleDiv p-1'>
                                    <div className="form-check ps-0 ">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={(formValue?.manage_trip_kms > 0) ? true : false}
                                            id='is_trip_km'
                                            onClick={(e) => setFormValue((s) => ({ ...s, manage_trip_kms: e.target.checked ? 1 : 0, manage_fuel: false, fuel_out: 0, vehicle_average: '', opening_fuel: '', fuel_amount: '' }))}
                                        />
                                        <label className="form-check-label" htmlFor='is_trip_km'> Manage Trip Kms </label>
                                    </div>
                                    {(formValue?.manage_trip_kms > 0) ?
                                        <div className='truck_checkBv mb-2 pt-0'>
                                            {
                                                constant.manageTripKm?.map((el, ind) => {
                                                    return (
                                                        <React.Fragment key={ind}>
                                                            <input
                                                                className="form-check-input _avPointer"
                                                                id={+ind + "manage_trip_kms" + el?.value}
                                                                type="radio"
                                                                name="manage_trip_kms"

                                                                checked={formValue?.manage_trip_kms === el?.value}
                                                                value={formValue?.manage_trip_kms ? formValue?.manage_trip_kms : ""}
                                                                onChange={({ target: { name, value } }) =>
                                                                    handleOnChange(name, el?.value)
                                                                }
                                                            />
                                                            <label htmlFor={+ind + "manage_trip_kms" + el.value} className="form-check-label" >
                                                                {el.label}
                                                            </label> &nbsp;
                                                        </React.Fragment>
                                                    )
                                                })
                                            }
                                        </div> : <></>}
                                </div>
                                {
                                    // (activeTab?.lorry_type === 'Truck' || activeTab?.lorry_type === 'LCV' || activeTab?.lorry_type === 'Hyva' || activeTab?.lorry_type === 'Trailer' || activeTab?.lorry_type === 'Tanker') && 
                                    (formValue?.vehicle_ownership !== 2) && (
                                        <React.Fragment>

                                            {(formValue?.manage_trip_kms !== 0) && (<><div className='singleDiv p-1'>
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id='is_manage_fuel'
                                                    value={formValue?.manage_fuel}
                                                    checked={formValue.manage_fuel ? true : false}
                                                    onClick={(e) => setFormValue((s) => ({ ...s, manage_fuel: e.target.checked, vehicle_average: '', opening_fuel: '', fuel_amount: '' }))}
                                                />
                                                <label className="form-check-label" htmlFor='is_manage_fuel'> Manage Fuel </label>
                                            </div>
                                                {
                                                    formValue?.manage_fuel ? (
                                                        <React.Fragment>
                                                            <div className='pr_procssBx_grid mb-3'>
                                                                <div className='halfDiv'>
                                                                    <CommonInput
                                                                        type="number"
                                                                        placeholder="Fleet Average"
                                                                        label="Fleet Average"
                                                                        name='vehicle_average'
                                                                        maxLength="4"
                                                                        onKeyDown={handleKeyDown}
                                                                        onInput={utils.maxLengthCheck}
                                                                        value={formValue.vehicle_average}
                                                                        onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                                                        focus={!!(typeof formError === "object" && formError?.vehicle_average)}
                                                                        error={!!(typeof formError === "object") ? formError?.vehicle_average : ""}
                                                                        onChange={({ target: { name, value } }) =>
                                                                            handleOnChange(name, value)
                                                                        }
                                                                    />
                                                                </div>

                                                                <div className='halfDiv _relatePos'>
                                                                    <CommonInput
                                                                        type="number"
                                                                        placeholder="Opening Fuel"
                                                                        label="Opening Fuel"
                                                                        name='opening_fuel'
                                                                        maxLength="6"
                                                                        onKeyDown={handleKeyDown}
                                                                        onInput={utils.maxLengthCheck}
                                                                        value={formValue.opening_fuel}
                                                                        onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                                                        focus={!!(typeof formError === "object" && formError?.opening_fuel)}
                                                                        error={!!(typeof formError === "object") ? formError?.opening_fuel : ""}
                                                                        onChange={({ target: { name, value } }) =>
                                                                            handleOnChange(name, value)
                                                                        }
                                                                    />
                                                                    <span className='_weightSpan' > LTR </span>
                                                                </div>

                                                                <div className='halfDiv'>
                                                                    <CommonInput
                                                                        type="number"
                                                                        placeholder="Fuel Amount"
                                                                        label="Fuel Amount"
                                                                        name='fuel_amount'
                                                                        maxLength="6"
                                                                        onInput={utils.maxLengthCheck}
                                                                        onKeyDown={handleKeyDown}
                                                                        value={formValue.fuel_amount}
                                                                        onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                                                        focus={!!(typeof formError === "object" && formError?.fuel_amount)}
                                                                        error={!!(typeof formError === "object") ? formError?.fuel_amount : ""}
                                                                        onChange={({ target: { name, value } }) =>
                                                                            handleOnChange(name, value)
                                                                        }
                                                                    />
                                                                </div>

                                                                <div className='halfDiv'>
                                                                    <CommonInput
                                                                        type="number"
                                                                        placeholder="Fuel Rate"
                                                                        label="Fuel Rate"
                                                                        name='fuel_rate'
                                                                        value={(formValue?.fuel_amount > 0 && formValue?.opening_fuel > 0) ? (formValue?.fuel_amount / formValue?.opening_fuel).toFixed(2) : ''}
                                                                        disabled
                                                                    // focus={!!(typeof formError === "object" && formError?.fuel_rate)}
                                                                    // error={!!(typeof formError === "object") ? formError?.fuel_rate : ""}
                                                                    // onChange={({ target: { name, value } }) =>
                                                                    //     handleOnChange(name, value)
                                                                    // }
                                                                    />
                                                                </div>
                                                            </div>
                                                        </React.Fragment>
                                                    ) : <></>
                                                }

                                                <div className='singleDiv p-1'>
                                                    <div className="form-check ps-0 ">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            checked={(formValue?.fuel_out > 0) ? true : false}
                                                            id='is_fuel_average'
                                                            onClick={(e) => setFormValue((s) => ({ ...s, fuel_out: e.target.checked ? 1 : 0 }))}
                                                        />
                                                        <label className="form-check-label" htmlFor='is_fuel_average'> Fuel Out & Average Amount at Trip End </label>
                                                    </div>
                                                    {(formValue?.fuel_out > 0) ? <div className='truck_checkBv mb-2 pt-0'>
                                                        {
                                                            constant.fuelOut_Average?.map((el, ind) => {
                                                                return (
                                                                    <React.Fragment key={ind}>
                                                                        <input
                                                                            className="form-check-input _avPointer"
                                                                            id={+ind + "fuel_out" + el?.value}
                                                                            type="radio"
                                                                            name="fuel_out"
                                                                            checked={formValue?.fuel_out === el?.value}
                                                                            value={formValue?.fuel_out ? formValue?.fuel_out : ""}
                                                                            onChange={({ target: { name, value } }) =>
                                                                                handleOnChange(name, el?.value)
                                                                            }
                                                                        />
                                                                        <label htmlFor={+ind + "fuel_out" + el.value} className="form-check-label" >
                                                                            {el.label}
                                                                        </label> &nbsp;
                                                                    </React.Fragment>
                                                                )
                                                            })
                                                        }
                                                    </div> : <></>}
                                                </div> </>)}

                                        </React.Fragment>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>

                {(formValue?.vehicle_ownership === 1 || formValue?.vehicle_ownership === 3) && (
                    <div className='pr_procssBx' id="addPartyContent">
                        <div className='pr_procssBx_grid'>
                            <div className='singleDiv' style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                                {/* <CustomSelect
                                    options={driverList?.map((el) => {
                                        return {
                                            label: el?.name,
                                            value: el?._id
                                        }
                                    })}
                                    name="driver_id"
                                    flotingLabel="Assign Driver"
                                    placeholder="Assign Driver"
                                    isDropdownTop={true}
                                    value={formValue?.driver_id}
                                    // focus={!!(typeof formError === "object" && formError?.driver_id)}
                                    error={!!(typeof formError === "object") ? formError?.driver_id : ""}
                                    onSelect={(data) => onhandleSelect(data, 'driver_id')}
                                    isAddButton={isChildDriverSuplier ? false : (isOpen?._id ? false : true)}
                                    addButtonAction={() => handleAddNewVehicleButtonAction(formValue?.firm_id)}
                                    isClearOption={true}
                                    isClearHandleChange={() => {
                                        setFormValue((s) => ({ ...s, driver_id: {} })) // label: 'Assign Driver', value: ''
                                    }}
                                /> */}

                                <CityDropdownForTrip
                                    label={"Assign Driver"}
                                    placeholder="Assign Driver"
                                    fetchData={fetchDriver}
                                    pageSize={20}
                                    onChange={(data) => {
                                        onhandleSelect(data, 'driver_id')

                                    }}

                                    selectedItem={formValue?.driver_id}

                                    isAddButton={masterChildDriver?.create === 1 ? (isChildDriverSuplier ? false : (isOpen?._id ? false : true)) : false}
                                    addButtonAction={() => handleAddNewVehicleButtonAction(formValue?.firm_id)}
                                    isClearOption={formValue?.driver_id?.value ? true : false}
                                    isClearHandleChange={() => {
                                        setFormValue((s) => ({ ...s, driver_id: {} })) // label: 'Assign Driver', value: ''
                                    }}
                                />

                                {(formValue?.driver_id?.firm_id?.firm) && <p className='offcanvas_heading_head' style={{ fontWeight: 400, fontSize: "12px", marginLeft: "5px", color: "#4A5565" }}>
                                    <img src={FirmImg} className='firm_icon_img' style={{ color: "#4A5565" }} /> {" "}
                                    {formValue?.driver_id?.firm_id?.firm && formValue?.driver_id?.firm_id?.firm}
                                </p>}
                            </div>
                        </div>
                    </div>
                )}

                {formValue?.vehicle_ownership === 2 && (
                    <div className='pr_procssBx' id="addPartyContent">
                        <div className='pr_procssBx_grid'>
                            <div className='singleDiv' style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                                {/* <CustomSelect
                                    options={supplierList}
                                    name="supplier_id"
                                    flotingLabel="Assign Supplier"
                                    placeholder="Assign Supplier" // Assign Supplier
                                    isDropdownTop={true}
                                    value={formValue?.supplier_id}
                                    // focus={!!(typeof formError === "object" && formError?.supplier_id)}
                                    error={!!(typeof formError === "object") ? formError?.supplier_id : ""}
                                    onSelect={(data) => onhandleSelect(data, 'supplier_id')}
                                    isAddButton={isChildDriverSuplier ? false : (isOpen?._id ? false : true)}
                                    addButtonAction={handleAddNewSupplierButtonAction}
                                    isClearOption={true}
                                    isClearHandleChange={() => {
                                        setFormValue((s) => ({ ...s, supplier_id: {} })) //  label: 'Assign Supplier', value: '' 
                                    }}
                                /> */}

                                <CityDropdownForTrip
                                    label={"Assign Supplier"}
                                    placeholder="Assign Supplier"
                                    fetchData={fetchSupplier}
                                    pageSize={20}
                                    onChange={(data) => {
                                        onhandleSelect(data, 'supplier_id')
                                    }}
                                    selectedItem={formValue?.supplier_id}
                                    isAddButton={masterChildSupplier?.create === 1 ? (isChildDriverSuplier ? false : (isOpen?._id ? false : true)) : false}
                                    addButtonAction={() => handleAddNewSupplierButtonAction(formValue?.firm_id)}
                                    error={!!(typeof formError === "object") ? formError?.supplier_id : ""}
                                    errorMessage={!!(typeof formError === "object") ? formError?.supplier_id : ""}
                                    isClearOption={formValue?.supplier_id?._id ? true : false}
                                    isClearHandleChange={() => {
                                        setFormValue((s) => ({ ...s, supplier_id: {} })) //  label: 'Assign Supplier', value: '' 
                                    }}

                                />
                                {(formValue?.supplier_id?.firm_id?.firm) && <p className='offcanvas_heading_head' style={{ fontWeight: 400, fontSize: "12px", marginLeft: "5px", color: "#4A5565" }}>
                                    <img src={FirmImg} className='firm_icon_img' style={{ color: "#4A5565" }} /> {" "}
                                    {formValue?.supplier_id?.firm_id?.firm && formValue?.supplier_id?.firm_id?.firm}
                                </p>}
                            </div>
                        </div>
                    </div>
                )}

            </div>

            <div className='offcanvas-footer'>
                <AddButton onClick={handleClick} disabled={!formValue?.vehicle_no || loading} name={loading ? 'Loading...' : (isOpen?._id ? 'Update Vehicle' : 'Add Vehicle')} />
                {(hideAddNewOption && !isOpen?._id) ? <button
                    className={isButtonDisabled || !formValue?.vehicle_no ? '_addNewComm_btn_disabled' : '_addNewComm_btn'}
                    onClick={handleResetFormAndSubmit}
                    disabled={isButtonDisabled || !formValue?.vehicle_no || loading}
                >
                    Add & New
                </button> : <></>}
            </div>
            {
                (youtubeVideos?.moduleName === 'vehicle_creation' && youtubeVideos?.moduleAction === true)
                && (
                    <YoutubeModal {...youtubeProps} />
                )
            }

            {fetchDocuments?.openModal && <FetchVehicleDocModal {...fetchDocModalProps} />}
        </>
    )
}

export default AddEditVehicleModal